// extracted by mini-css-extract-plugin
export var audioPlayer = "_tg-0";